export default __webpack_public_path__ + "static/media/Q5.4280c3bd.jpg";